import React, { useEffect, useRef, useState } from "react";

const Chips = ({values, disabled, onChange}) => {
    const addRef = useRef(null);
    const [agregando, setAgregando] = useState(false);
    const [nuevoElemento, setNuevoElemento] = useState('');

    const add = () => {
        setAgregando(false);

        if(!nuevoElemento) return;

        onChange([...(values ?? []), nuevoElemento]);

        setNuevoElemento("");
    };

    const remover = (index) => {
        if (disabled) return;

        values.splice(index, 1);

        onChange(values);
    };

    useEffect(() => {
        addRef.current?.focus()
    }, [agregando]);

    return <>
        <div className="row m-0 mt-2 p-0">
            {(values ?? []).map((value, index) => <span key={index} className="badge badge-danger text-capitalize py-1 mr-1 my-1">
                {value}&nbsp;&nbsp;
                <i className="fas fa-times-circle" style={{cursor: "pointer"}} onClick={() => remover(index)}></i>
            </span>)}

            {!agregando && <i className="fas fa-plus-square text-success my-auto" style={{cursor: "pointer", fontSize: "20px"}} onClick={() => setAgregando(true)}></i>}

        </div>

        <div className="mt-2">
            {agregando && <input
                ref={addRef}
                className="form-control"
                value={nuevoElemento}
                onChange={(e) => setNuevoElemento(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') add();
                }}
                onBlur={add}
                />}
        </div>
    </>;
};

export default Chips;